import {DetailScreen} from '../mapping-classes/detail-screen';
import {DetailPanel} from '../mapping-classes/detail-panel';
import {DetailLabel} from '../mapping-classes/detail-label';
import {ButtonData} from "../mapping-classes/button-data";

export class Icmasbabonnement implements DetailScreen {
  buttons;
  restrictedData: boolean;
  title: string;
  actualityDateTime: string;
  panels: DetailPanel[];
  nameValues: DetailLabel[];
  shieldedText = 'Afgeschermd';
  errorText: string;

  constructor(response: any) {
    this.title = 'ASB Abonnement';
    this.buttons = [];
    this.restrictedData = false;
    if (response.detailsViewObject) {
      this.title = response.detailsViewObject.commercialProductTypeName || this.title;
      this.actualityDateTime = response.detailsViewObject.profileCreationTime;
    }

    if (response.listOfError && response.listOfError.length) {
      this.createErrorMessage(response);
    } else {
      this.panels = [];
      this.nameValues = [];
      this.setPanels();
      this.setNameAndValues(response);
      this.addValues(response);
      this.addButtons(response.detailsViewObject);
    }
  }

  addButtons(res) {
    const data =  {
      arrangementNumber: res.arrangementNumber
    };
    const bbanNumber = res.accountNumber.slice(8);
    this.buttons.push(new ButtonData(
      'icmasbabonnement',
      null,
      null,
      null,
      'B&O Cockpit',
      null,
      `https://hub.rabobank.nl/silver/cockpit/bookings?accountNumber=${bbanNumber}&accountCurrency=EUR`, data));
  }

  setPanels() {
    this.panels.push(new DetailPanel('Productkenmerken'));
    this.panels.push(new DetailPanel('Productafspraken'));
    const productAfsprakenPanel: DetailPanel = this.panels[1];
    productAfsprakenPanel.subPanels.push(new DetailPanel('Rekening'));
    productAfsprakenPanel.subPanels.push(new DetailPanel('Transactie informatie'));
  }

  setNameAndValues(response?) {
    const productDetailsPanel: DetailPanel = this.panels[0];
    const productAgreements:  DetailPanel = this.panels[1];

    this.fillProductDetailsPanel(productDetailsPanel);
    this.fillProductAgreementsPanel(productAgreements);
  }

  addValues(response: any) {
    const obj = response.detailsViewObject;
    const productDetailsPanel: DetailPanel = this.panels[0];
    const productAgreementsPanel: DetailPanel = this.panels[1];
    this.addValuesToProductDetailsPanel(productDetailsPanel, obj);
    this.addValuesToProductAgreementsPanel(productAgreementsPanel, obj);
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.errorText = 'Product niet gevonden.';
      }
    }
  }

  private fillProductDetailsPanel(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('accountNumber', new DetailLabel('Rekeningnummer'));
    productDetailsPanel.nameAndValues.set('currency', new DetailLabel('Muntsoort'));
    productDetailsPanel.nameAndValues.set('asbmt94xbic', new DetailLabel('Verantwoording BIC'));
    productDetailsPanel.nameAndValues.set('asbmt94xbicLandBank', new DetailLabel('Land Bank'));
  }

  private addValuesToProductDetailsPanel(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('accountNumber').setValue(obj.accountNumber || '-');
    productDetailsPanel.nameAndValues.get('currency').setValue(obj.currency || '-');
    productDetailsPanel.nameAndValues.get('asbmt94xbic').setValue(obj.asbmt94xbic || '-');
    productDetailsPanel.nameAndValues.get('asbmt94xbicLandBank').setValue((obj.asbmt94xbic) ? obj.asbmt94xbic.substring(4, 6) : '-');
  }

  private fillProductAgreementsPanel(productDetailsPanel: DetailPanel) {
    const rekeningSubPanel: DetailPanel = productDetailsPanel.subPanels[0];
    rekeningSubPanel.nameAndValues.set('startRekening', new DetailLabel('Start rekening'));
    rekeningSubPanel.nameAndValues.set('eindeRekening', new DetailLabel('Einde rekening'));
    rekeningSubPanel.nameAndValues.set('rekeningType', new DetailLabel('Rekening type'));

    const transactieInformatieSubPanel: DetailPanel = productDetailsPanel.subPanels[1];
    transactieInformatieSubPanel.nameAndValues.set('verantwoordingBic', new DetailLabel('Verantwoording BIC'));
    transactieInformatieSubPanel.nameAndValues.set('initiatieBic', new DetailLabel('Initiatie BIC'));
    transactieInformatieSubPanel.nameAndValues.set('initiatie', new DetailLabel('Initiatie'));
    transactieInformatieSubPanel.nameAndValues.set('eodFrequentie', new DetailLabel('EOD frequentie'));
    transactieInformatieSubPanel.nameAndValues.set('itrFrequentie', new DetailLabel('ITR frequentie'));
  }

  private addValuesToProductAgreementsPanel(productDetailsPanel: DetailPanel, obj) {
    const rekeningSubPanel: DetailPanel = productDetailsPanel.subPanels[0];
    rekeningSubPanel.nameAndValues.get('startRekening').setValue(obj.startDateString || '-');
    rekeningSubPanel.nameAndValues.get('eindeRekening').setValue(obj.endDateString || '-');
    rekeningSubPanel.nameAndValues.get('rekeningType').setValue(obj.accountType || '-');

    const transactieInformatieSubPanel: DetailPanel = productDetailsPanel.subPanels[1];
    transactieInformatieSubPanel.nameAndValues.get('verantwoordingBic').setValue(obj.asbmt94xbic || '-');
    transactieInformatieSubPanel.nameAndValues.get('initiatieBic').setValue(obj.asbmt101bic || '-');
    transactieInformatieSubPanel.nameAndValues.get('initiatie').setValue((obj.paymentInitiationAllowed) ? "Ja" : "Nee"  || '-');
    transactieInformatieSubPanel.nameAndValues.get('eodFrequentie').setValue(obj.eodFrequency || '-');
    transactieInformatieSubPanel.nameAndValues.get('itrFrequentie').setValue(obj.itrFrequency || '-');
  }
}
